import { LEAD_DETAILS_COLUMN_STORAGE_KEYS } from "./leadDetailsColumnStorage";
import { EXPORT_PROGRESS_STORAGE_PREFIX } from "./exportProgressStorage";

const SENSITIVE_LOCAL_STORAGE_PREFIXES = [
  "overview-session-",
  "overview-active-tab",
  "lead-details-modal-draft-",
  "outbound-call-form-draft-",
  "lead-details-active-tab:",
] as const;

const SENSITIVE_LOCAL_STORAGE_EXACT_KEYS = [
  ...Object.values(LEAD_DETAILS_COLUMN_STORAGE_KEYS),
] as const;

/** Remove persisted UI drafts, tab state, and column layouts from localStorage on logout. */
export function clearSensitiveClientStorage(): void {
  if (typeof window === "undefined") return;

  const keysToRemove = new Set<string>(SENSITIVE_LOCAL_STORAGE_EXACT_KEYS);

  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (!key) continue;
    if (
      SENSITIVE_LOCAL_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))
    ) {
      keysToRemove.add(key);
    }
  }

  keysToRemove.forEach((key) => {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // ignore quota / private mode errors
    }
  });

  try {
    const sessionKeys: string[] = [];
    for (let index = 0; index < window.sessionStorage.length; index += 1) {
      const key = window.sessionStorage.key(index);
      if (key && key.startsWith(EXPORT_PROGRESS_STORAGE_PREFIX)) {
        sessionKeys.push(key);
      }
    }
    sessionKeys.forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    // ignore quota / private mode errors
  }
}
